export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11872.4c2c585a.jpg";